import { Tag } from 'antd';
import React from 'react';
import { ColumnsType } from 'antd/es/table';

import { AutoBroadcastViewButton } from '../components/AutoBroadcastViewButton';
import { AutoBroadcastProps } from '../service/autoBroadcast.interface';

export const getColumns = (): ColumnsType<AutoBroadcastProps> => [
    {
        title: 'Имя пользователя',
        dataIndex: 'full_name',
        key: 'full_name',
    },

    {
        title: 'ID Telegram',
        dataIndex: 'chat_id',
        key: 'chat_id',
    },

    {
        title: 'Юзернэйм',
        dataIndex: 'user_name',
        key: 'user_name',
    },

    {
        title: 'Триггер',
        dataIndex: 'type_label',
        key: 'type_label',
    },

    {
        title: 'Статус',
        dataIndex: 'status',
        key: 'status',
        render: status => <Tag>{status}</Tag>,
    },

    {
        title: '',
        key: 'operation',
        render: (_, item) => <AutoBroadcastViewButton data={item} />,
    },
];
